export enum GraphTokenState {
    None,
    Failed,
    Successful,
}
